module.exports = __webpack_public_path__ + "static/media/525SunsetAveNW_2018-06-06_52.c46fe612.jpg";